<template>
  <div v-if="broker != null">

    <div class="flex items-center">
      <PageHeader :label="isUserThisBroker ? 'Templates' : broker.first_name + ' ' + broker.last_name + ' Templates'"></PageHeader>
      <button v-on:click="showTemplateTypeModal()"
        class="ml-8 bg-blue-500 hover:bg-blue-600 text-xs font-semibold px-4 py-1 rounded text-white">+ New Template</button>
    </div>

    <div class="my-8">
      <template v-if="templates == null"></template>

      <template v-else-if="templates != null && templates.length == 0">
        <div class="text-gray-600 bg-gray-200 p-6 rounded border border-gray-300">

          <div class="text-center">
            <img src="https://cdn0.iconfinder.com/data/icons/25-essential-ui-pack-1/32/Delete-512.png" 
              class="w-12 inline" />
          </div>

          <div class="text-gray-700 text-base mt-4 text-center leading-normal">
            You have not added any templates. 
            <a href="#" @click.prevent="showTemplateTypeModal()" class="underline">Let's add one now</a>.
          </div>
        </div>
      </template>

      <template v-else>

        <template v-if="hasTemplateType('asset')">
          <div class="text-base text-gray-700">Asset templates</div>
          <div class="mt-4 flex flex-wrap -mx-2">
            <template v-for="(template, index) in templates">
              <template v-if="template.type == 'asset'">
                <Template :template="template" 
                  :index="index"
                  :showTemplateModal="showTemplateModal"
                  :deleteTemplate="deleteTemplate" />
              </template>
            </template>
          </div>
        </template>

        <template v-if="hasTemplateType('liability')">
          <div class="text-base text-gray-700 mt-8">Liability templates</div>
          <div class="mt-4 flex flex-wrap -mx-2">
            <template v-for="(template, index) in templates">
              <template v-if="template.type == 'liability'">
                <Template :template="template" 
                  :index="index"
                  :showTemplateModal="showTemplateModal"
                  :deleteTemplate="deleteTemplate" />
              </template>
            </template>
          </div>
        </template>

        <template v-if="hasTemplateType('document')">
          <div class="text-base text-gray-700 mt-8">Document templates</div>
          <div class="mt-4 flex flex-wrap -mx-2">
            <template v-for="(template, index) in templates">
              <template v-if="template.type == 'document'">
                
                <Template :template="template" 
                  :index="index"
                  :showTemplateModal="showTemplateModal"
                  :deleteTemplate="deleteTemplate" />
              </template>
            </template>
          </div>
        </template>

        <template v-if="hasTemplateType('client')">
          <div class="text-base text-gray-700 mt-8">Client templates</div>
          <div class="mt-4 flex flex-wrap -mx-2">
            <template v-for="(template, index) in templates">
              <template v-if="template.type == 'client'">
                
                <Template :template="template" 
                  :index="index"
                  :showTemplateModal="showTemplateModal"
                  :deleteTemplate="deleteTemplate" />
              </template>
            </template>
          </div>
        </template>

      </template>

    </div>

    <TemplateTypeModal />
    <AssetTemplateModal />
    <LiabilityTemplateModal />
    <DocumentTemplateModal />
    <DocumentTypeModal />
    <ClientTemplateModal :templates="templates" />
  </div>
</template>

<script>
  import { EventBus }           from '@/shared/event-bus'
  import Template               from './Template'
  import PageHeader             from '@/shared/components/headers/PageHeader'
  import TemplateTypeModal      from './TemplateTypeModal'
  import AssetTemplateModal     from './AssetTemplateModal'
  import LiabilityTemplateModal from './LiabilityTemplateModal'
  import DocumentTemplateModal  from './DocumentTemplateModal'
  import DocumentTypeModal      from './DocumentTypeModal'
  import ClientTemplateModal    from './ClientTemplateModal'

  export default {

    components: {
      PageHeader,
      AssetTemplateModal,
      LiabilityTemplateModal,
      DocumentTemplateModal,
      TemplateTypeModal,
      DocumentTypeModal,
      Template,
      ClientTemplateModal
    },

    data () {
      return {
        loading  : false,
        broker   : null,
        templates: null
      }
    },

    created() {
      // am I looking my own?
      if(this.$store.state[this.$store.state.view + 'Module'].broker.id == this.$route.params.brokerId) {
        this.broker = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      }

      else if(this.isUserAdmin()) {
        this.apiGet({
          brokerId : this.$route.params.brokerId
        }, 'broker/detail', (broker) => {
          this.broker = broker
        })
      }

      if(this.broker != null) {
        this.getTemplates()
      }
    },

    mounted() {
      EventBus.$on('get-templates', () => {
        this.getTemplates()
      })
    },

    beforeDestroy() {
      EventBus.$off('get-templates')
    },

    methods : {
      getTemplates() {
        this.showLoader("Loading...")
        this.apiGet({
          type : 'all'
        }, 'template/list', (templates) => {
          this.hideLoader()
          this.templates = templates
        })
      },

      hasTemplateType(type) {
        if(this.templates != null) {
          for(let i=0; i < this.templates.length; i++) {
            if(this.templates[i].type == type) {
              return true
            }
          }
        }

        return false
      },

      showTemplateTypeModal() {
        this.$modal.show('template-type-modal')
      },

      showTemplateModal(template) {
        this.$modal.show(template.type + '-template-modal', {
          template : template
        })
      },

      deleteTemplate(templateId, index) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                templateId : templateId
              }, 'template/delete', () => {
                this.$modal.hide('confirm-modal')
                this.templates.splice(index, 1)
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Template deleted successfully"
                })
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    },
  }
</script>